import * as t from "./actionTypes";
import { activityService } from "client-app-core";
import {
	updateContext,
	updateContextProperty,
	updateContextPropertyWithDotNotation
} from "orion-components/ContextualData/Actions";
import {
	addContext,
	removeContext,
	unsubscribeFromContext,
	startAttachmentStream,
	startActivityStream
} from "orion-components/ContextualData/Actions";
import { toggleOpen } from "orion-components/Dock/actions";
export { unsubscribeFromFeed } from "orion-components/ContextualData/Actions";
export { closeNotification, reopenNotification } from "orion-components/Dock/Notifications/actions";
export { reopenAlert, dumpArchive } from "orion-components/Dock/Alerts/actions";
export { loadProfile } from "orion-components/ContextPanel/Actions";
// export { addSpotlight } from "orion-components/Map/Tools/Actions";

export const getActivityDetails = id => {
	return dispatch => {
		activityService.getActivityDetails(id, (err, response) => {
			if (err) {
				console.log("ERR", err);
			} else {
				dispatch(updateContext(id, response));
			}
		});
	};
};

const _openAlertProfile = alertId => {
	return {
		type: t.OPEN_ALERT_PROFILE,
		payload: {
			id: alertId
		}
	};
};

const _closeAlertProfile = () => {
	return {
		type: t.CLOSE_ALERT_PROFILE
	};
};

export const openAlertProfile = (notification, forReplay, callback, disableDock = false) => {
	return (dispatch, getState) => {
		const { id, activityId } = notification;
		const isDownloadedReplay = typeof window !== "undefined" && Boolean(window.api);
		const state = getState();
		const { expandedAlert, isOpen } = state.appState.dock.dockData;
		const replayAlertDetails = isDownloadedReplay ? notification : null;
		if (!isOpen && !disableDock) {
			dispatch(toggleOpen());
		}
		if (expandedAlert && expandedAlert !== id) {
			dispatch(unsubscribeFromContext(expandedAlert, "dock"));
			dispatch(_closeAlertProfile());
			dispatch(removeContext(expandedAlert));
		}
		dispatch(addContext(id, notification));
		if (!forReplay) {
			dispatch(startActivityStream(id, "alert", "dock"));
			// Stream attachments from activity but the data and sub should be stored on the alert context
			dispatch(startAttachmentStream(activityId, "dock", id));
		} else if (isDownloadedReplay) {
			if (notification.summary || replayAlertDetails?.summary) {
				dispatch(
					updateContextPropertyWithDotNotation(
						id,
						"entity.summary",
						notification.summary || replayAlertDetails.summary
					)
				);
			}
			dispatch(
				updateContextProperty(
					id,
					"activities",
					notification.activities?.length ? notification.activities : replayAlertDetails?.activities || []
				)
			);
			dispatch(
				updateContextProperty(
					id,
					"lists",
					Object.keys(notification.lists || {}).length ? notification.lists : replayAlertDetails?.lists || {}
				)
			);
			dispatch(updateContextProperty(id, "attachments", notification.attachments || []));
		} else {
			// do we need to do something else here, or leave it up to the widgets to pull in the static data
		}
		dispatch(_openAlertProfile(id));
		if (callback) callback(isOpen);
	};
};

export const closeAlertProfile = alertId => {
	return dispatch => {
		dispatch(unsubscribeFromContext(alertId, "dock"));
		dispatch(_closeAlertProfile());
		dispatch(removeContext(alertId));
	};
};
